import React, { Suspense, useState } from 'react';
import { sRGBEncoding, PCFShadowMap, Vector3 } from 'three';
import { Canvas } from 'react-three-fiber';
import { useControl } from 'react-three-gui';
import './App.css';
import World from './components/World';
import BootScene from './components/BootScene';

declare global {
  interface Window {
    FoiSDK: {
      onObjectClick?: (name: string) => void;
      onVegetableClick?: (name: string) => void;
    };
    InternalSDK: {
      onObjectClick?: (name: string) => void;
      onVegetableClick?: (name: string) => void;
    };
  }
}

export enum WorldState {
  INITIAL,
  STARTING,
  STARTED,
  COMPLETE,
}

const INITIAL_POSITION = new Vector3(280, 15, -5);

function App() {
  window.FoiSDK = window.FoiSDK || {};

  const sunIntensity = useControl('Sun Intensity', { type: 'number', value: 9, spring: false, min: 2, max: 20 });
  const sunHeight = useControl('Sun Height', { type: 'number', value: 230, spring: false, min: 50, max: 300 });
  // const displayPoleBeans = useControl('Display Pole Beans', { type: 'boolean', value: true });
  const displayPoleBeans = true;
  const startTiming = useControl('Start Timing (ms)', { type: 'number', value: 3000, spring: false, min: 1, max: 5000 });
  
  const [worldState, setWorldState] = useState(WorldState.STARTED);

  function startingExperience() {
    setWorldState(WorldState.STARTED);

    setTimeout(() => {
      setWorldState(WorldState.COMPLETE);
    }, startTiming);
  }

  // Create Public FoiSDK
  const API = {
    onVegetableClick: (name: string) => {
      if (window.FoiSDK.onVegetableClick)
        window.FoiSDK.onVegetableClick(name);
    },
    onObjectClick: (name: string) => {
      if (window.FoiSDK.onObjectClick) {
        window.FoiSDK.onObjectClick(name);
      }
    },
  };

  return (
    <>
      {worldState === WorldState.STARTING && (
        <div style={{ position: 'absolute', top: '50%', left: 'calc(50% - 100px)', zIndex: 999 }}>
          <button className="glow-on-hover" onClick={startingExperience}>START EXPERIENCE</button>
        </div>
      )}

      <Canvas
        gl2
        concurrent
        shadowMap
        camera={{ position: INITIAL_POSITION }}
        onCreated={({ gl }) => {
          const _gl: any = gl as any;
          // _gl.gammaInput = true;
          // _gl.toneMapping = LinearToneMapping;
          // _gl.toneMappingExposure = 1;
          _gl.shadowMap.enabled = true;
          _gl.outputEncoding = sRGBEncoding;
          // _gl.textureEncoding = sRGBEncoding;
          // gl.shadowMap.enabled = true;
          gl.shadowMap.type = PCFShadowMap;
          _gl.physicallyCorrectLights = true;
          // _gl.outputEncoding = sRGBEncoding;
          // _gl.setClearColor( 0xcccccc );
          _gl.setPixelRatio(1);

          console.log('gl', gl);
        }}
        
      >
        <Suspense fallback={null}>
          <BootScene worldState={worldState} setWorldState={setWorldState} />
          <World
            worldState={worldState}
            isStarted={worldState !== WorldState.INITIAL}
            sunIntensity={Math.ceil(sunIntensity)}
            sunHeight={sunHeight}
            displayPoleBeans={displayPoleBeans}
            displayPopover={worldState !== WorldState.INITIAL}
            onVegetableClick={API.onVegetableClick}
            onObjectClick={API.onObjectClick}
          />
        </Suspense>
      </Canvas>
      {/* <Controls /> */}
    </>
  );
}

export default App;
